// extracted by mini-css-extract-plugin
export default {"rightContainer":"Header_rightContainer__+47Rj"};